export type SimpleRoofTypes = 'W' | 'C' | 'M' | 'S' | 'T' | 'O';

export function mapExpandedToSimpleRoofType(roofType: string) {
  switch (roofType) {
    case 'AF':
      return 'C';
    case 'AR':
      return 'C';
    case 'SL':
      return 'S';
    case 'CL':
      return 'T';
    case 'CO':
      return 'T';
    case 'MI':
      return 'T';
    case 'SP':
      return 'T';
    case 'CP':
      return 'M';
    case 'ST':
      return 'M';
    case 'TN':
      return 'M';
    case 'FB':
      return 'O';
    case 'FM':
      return 'O';
    case 'PL':
      return 'O';
    case 'RB':
      return 'O';
    case 'BU':
      return 'W';
    case 'WD':
      return 'W';
    case 'WS':
      return 'W';
    case 'NE':
      return 'W';
    case 'VC':
      return 'W';
    case 'RR':
      return 'O';
    case 'BUP':
      return 'O';
    case 'SPF':
      return 'O';
    default:
      return 'O';
  }
}

export function mapSimpleToExpandedRoofType(roofType: string) {
  switch (roofType) {
    case 'W':
      return 'WD';
    case 'S':
      return 'SL';
    case 'T':
      return 'CL';
    case 'M':
      return 'ST';
    default:
      return 'AF';
  }
}
